import { render, staticRenderFns } from "./DashBoardOverView.vue?vue&type=template&id=4561a8ca&scoped=true&"
import script from "./DashBoardOverView.vue?vue&type=script&lang=js&"
export * from "./DashBoardOverView.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardOverView.vue?vue&type=style&index=0&id=4561a8ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561a8ca",
  null
  
)

export default component.exports